import React, { useEffect, useState } from 'react';
import Select, { SelectOption } from '@amzn/meridian/select';

/*
Creates an editable cell renderer with dropdown Select, as part of dynamic table component. 
Allows data elements within dynamic table to be editable inline.

Note that validationHandler must return a promise.
reference - https://react-table.tanstack.com/docs/examples/editable-data

*/
export const EditableDropdownCell = ({
  column,
  row,
  value: initialValue,
  onChange = null,
  validationHandler = null,
  selectOptions = [],
}) => {
  const [value, setValue] = useState(initialValue);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleChange = newValue => {
    setValue(newValue);

    if (validationHandler && row.original.isEdit) {
      validationHandler(newValue)
        .then(() => {
          setError(false);
          setErrorMessage(null);
        })
        .catch(error => {
          setError(true);
          setErrorMessage(error.message);
        });
    }
    onChange(newValue);
  };

  useEffect(() => {
    setValue(initialValue);

    if (validationHandler && row.original.isEdit) {
      validationHandler(initialValue)
        .then(() => {
          setError(false);
          setErrorMessage(null);
        })
        .catch(error => {
          setError(true);
          setErrorMessage(error.message);
        });
    }
  }, [initialValue, row.original.isEdit, validationHandler]);

  return (
    <Select
      value={value}
      onChange={handleChange}
      disabled={!row.original.isEdit}
      error={error}
      errorMessage={row.original.isEdit ? errorMessage : null}
    >
      {selectOptions.map(option => (
        <SelectOption key={option.value} value={option.value} label={option.label} />
      ))}
    </Select>
  );
};
